export function cn(...parts: (string | undefined | false)[]) {
  return parts.filter(Boolean).join(' ')
}
